<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  hotKey: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="w-full">
    <!-- SVG para a HotKey ENTER -->
    <template v-if="hotKey === 'enter'">
      <!-- Light Version -->
      <svg
        width="318"
        height="100"
        viewBox="0 0 318 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="block object-cover w-full dark:hidden"
      >
        <rect
          width="318"
          height="100"
          rx="8"
          fill="url(#paint0_linear_487_6940)"
        />
        <g filter="url(#filter0_d_487_6940)">
          <rect
            x="224"
            y="56"
            width="78"
            height="28"
            rx="6"
            fill="var(--woot-500, #30a46c)"
          />
          <text
            x="263"
            y="70"
            fill="white"
            font-family="system-ui, -apple-system, sans-serif"
            font-size="12"
            font-weight="600"
            text-anchor="middle"
            dominant-baseline="central"
          >
            {{ t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.CARD.SEND_BUTTON_ENTER') }}
          </text>
        </g>
        <rect x="8" y="10" width="202" height="12" rx="6" fill="#FDFDFD" />
        <rect x="8" y="30" width="137" height="12" rx="6" fill="#FDFDFD" />
        <defs>
          <filter
            id="filter0_d_487_6940"
            x="223.167"
            y="55.5833"
            width="79.6667"
            height="29.6667"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.416667" />
            <feGaussianBlur stdDeviation="0.416667" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.214953 0 0 0 0 0.364486 0 0 0 0 0.985047 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_487_6940"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_487_6940"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_487_6940"
            x1="0"
            y1="50"
            x2="318"
            y2="50"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#ECEEF2" />
            <stop offset="1" stop-color="var(--woot-50, #ddf3e4)" />
          </linearGradient>
        </defs>
      </svg>

      <!-- Dark Version -->
      <svg
        width="318"
        height="100"
        viewBox="0 0 318 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="hidden object-cover w-full dark:block"
      >
        <rect
          width="318"
          height="100"
          rx="8"
          fill="url(#paint0_linear_487_4414)"
        />
        <g filter="url(#filter0_d_487_4414)">
          <rect
            x="224"
            y="56"
            width="78"
            height="28"
            rx="6"
            fill="var(--woot-500, #30a46c)"
          />
          <text
            x="263"
            y="70"
            fill="white"
            font-family="system-ui, -apple-system, sans-serif"
            font-size="12"
            font-weight="600"
            text-anchor="middle"
            dominant-baseline="central"
          >
            {{ t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.CARD.SEND_BUTTON_ENTER') }}
          </text>
        </g>
        <rect x="8" y="10" width="202" height="12" rx="6" fill="#383942" />
        <rect x="8" y="30" width="137" height="12" rx="6" fill="#383942" />
        <defs>
          <filter
            id="filter0_d_487_4414"
            x="223.167"
            y="55.5833"
            width="79.6667"
            height="29.6667"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.416667" />
            <feGaussianBlur stdDeviation="0.416667" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.214953 0 0 0 0 0.364486 0 0 0 0 0.985047 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_487_4414"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_487_4414"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_487_4414"
            x1="0"
            y1="50"
            x2="318"
            y2="50"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.39" stop-color="#2A2B31" />
            <stop offset="1" stop-color="var(--woot-900, #0d1f17)" />
          </linearGradient>
        </defs>
      </svg>
    </template>

    <!-- SVG para a HotKey CMD_ENTER -->
    <template v-else-if="hotKey === 'cmd_enter'">
      <!-- Light Version -->
      <svg
        width="318"
        height="100"
        viewBox="0 0 318 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="block object-cover w-full dark:hidden"
      >
        <rect
          width="318"
          height="100"
          rx="8"
          fill="url(#paint0_linear_487_6953)"
        />
        <g filter="url(#filter0_d_487_6953)">
          <rect
            x="198"
            y="56"
            width="104"
            height="28"
            rx="6"
            fill="var(--woot-500, #30a46c)"
          />
          <text
            x="250"
            y="70"
            fill="white"
            font-family="system-ui, -apple-system, sans-serif"
            font-size="12"
            font-weight="600"
            text-anchor="middle"
            dominant-baseline="central"
          >
            {{
              t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.CARD.SEND_BUTTON_CMD_ENTER')
            }}
          </text>
        </g>
        <rect x="8" y="10" width="202" height="12" rx="6" fill="#FDFDFD" />
        <rect x="8" y="30" width="137" height="12" rx="6" fill="#FDFDFD" />
        <defs>
          <filter
            id="filter0_d_487_6953"
            x="197.167"
            y="55.5833"
            width="105.667"
            height="29.6667"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.416667" />
            <feGaussianBlur stdDeviation="0.416667" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.214953 0 0 0 0 0.364486 0 0 0 0 0.985047 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_487_6953"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_487_6953"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_487_6953"
            x1="0"
            y1="50"
            x2="318"
            y2="50"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#ECEEF2" />
            <stop offset="1" stop-color="var(--woot-50, #ddf3e4)" />
          </linearGradient>
        </defs>
      </svg>

      <!-- Dark Version -->
      <svg
        width="318"
        height="100"
        viewBox="0 0 318 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="hidden object-cover w-full dark:block"
      >
        <rect
          width="318"
          height="100"
          rx="8"
          fill="url(#paint0_linear_487_4427)"
        />
        <g filter="url(#filter0_d_487_4427)">
          <rect
            x="198"
            y="56"
            width="104"
            height="28"
            rx="6"
            fill="var(--woot-500, #30a46c)"
          />
          <text
            x="250"
            y="70"
            fill="white"
            font-family="system-ui, -apple-system, sans-serif"
            font-size="12"
            font-weight="600"
            text-anchor="middle"
            dominant-baseline="central"
          >
            {{
              t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.CARD.SEND_BUTTON_CMD_ENTER')
            }}
          </text>
        </g>
        <rect x="8" y="10" width="202" height="12" rx="6" fill="#383942" />
        <rect x="8" y="30" width="137" height="12" rx="6" fill="#383942" />
        <defs>
          <filter
            id="filter0_d_487_4427"
            x="197.167"
            y="55.5833"
            width="105.667"
            height="29.6667"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.416667" />
            <feGaussianBlur stdDeviation="0.416667" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.214953 0 0 0 0 0.364486 0 0 0 0 0.985047 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_487_4427"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_487_4427"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_487_4427"
            x1="0"
            y1="50"
            x2="318"
            y2="50"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.39" stop-color="#2A2B31" />
            <stop offset="1" stop-color="var(--woot-900, #0d1f17)" />
          </linearGradient>
        </defs>
      </svg>
    </template>
  </div>
</template>
